<template>
  <div class="z2-info-storage">
    <div
      class="d-flex align-items-center justify-content-between px-2 border-bottom"
      style="height: 56px">
      <div
        class="pointer"
        @click="$emit('close'); fetchDataInfo(conversation, 6)">
        <IconV2
          name="v2-arrow2_left"
          size="24px" />
      </div>
      <div class="font-16 fw-500 flex-1 text-center">
        <span class="me-3">Lưu trữ</span>
      </div>
      <div
        @click="onResetSelectMulti"
        class="me-2 px-2 py-1 rounded-2 pointer btn-header font-13 text-blue500"
        style="background-color: #e1edfd">
        {{ selectMulti ? "Hủy" : "Chọn nhiều" }}
      </div>
    </div>
    <div class="py-2 border-bottom">
      <el-tabs
        style="background-color: white"
        v-model="tabType"
        @tab-click="handleClick">
        <el-tab-pane name="media">
          <span
            class="ms-3"
            style="width: 85px"
            slot="label">
            Ảnh / Video
          </span>
          <MessageStorageMedia
            v-if="tabType === 'media'"
            ref="messageMedia"
            :selectMulti="selectMulti"
            :messages="messages"
            :conversation="conversation"
            @showMenu="showMenu"
            @reset="selectMulti = false"
            @loadMoreImg="loadMoreImg"/>
        </el-tab-pane>
        <el-tab-pane name="file">
          <span
            style="width: 85px"
            slot="label">
            Tài liệu
          </span>
          <MessageStorageFile
            v-if="tabType === 'file'"
            ref="messageFile"
            :selectMulti="selectMulti"
            :messages="messages"
            :conversation="conversation"
            @showMenu="showMenu"
            @reset="selectMulti = false"
            @loadMoreImg="loadMoreImg"/>
        </el-tab-pane>
        <el-tab-pane name="link">
          <span
            style="width: 85px"
            slot="label">
            Liên kết
          </span>
          <MessageStorageLink
            v-if="tabType === 'link'"
            ref="messageLink"
            :selectMulti="selectMulti"
            :messages="messages"
            :conversation="conversation"
            @showMenu="showMenu"
            @reset="selectMulti = false"
            @loadMoreImg="loadMoreImg"/>
        </el-tab-pane>
      </el-tabs>
    </div>
    <MenuMessageTab
      v-show="isMenuVisible"
      :conversation="conversation"
      :message="menuMessage"
      @hideMenu="isMenuVisible = false" />
  </div>
</template>

<script>
import { convertData } from "../lib/conversation";
import { groupByDay } from "../lib/date-util";
import MessageStorageMedia from "./MessageStorageMedia.vue";
import MessageStorageFile from "./MessageStorageFile.vue";
import MessageStorageLink from "./MessageStorageLink.vue";
import MenuMessageTab from "./Popup/MenuMessageTab.vue";

export default {
  props: ["conversation", "messageType", "profile"],
  components: {
    MessageStorageMedia,
    MessageStorageFile,
    MessageStorageLink,
    MenuMessageTab,
  },
  data() {
    return {
      searchMember: "",
      tabType: "",
      messages: [],
      dayList: [],
      isMenuVisible: false,
      menuMessage: {},

      selectMulti: false,
    };
  },
  watch: {
    tabType() {
      // this.getMessage();
      this.fetchDataInfo(this.conversation);
    },
  },
  methods: {
    handleClick() {},
    showMenu(e, message) {
      this.isMenuVisible = true;
      this.menuMessage = message;
      this.setPosition(e);
    },
    setPosition(event) {
      const menu = document.getElementById("context-menu-message");
      if (window.innerWidth - event.clientX < 118) {
        menu.style.left = `${event.clientX - 100}px`;
      } else {
        menu.style.left = `${event.clientX}px`;
      }
      if (window.innerHeight - event.clientY < 165) {
        menu.style.top = `${event.clientY - 165}px`;
      } else {
        menu.style.top = `${event.clientY + 12}px`;
      }
    },
    handleFilterMessageTab(data) {
      this.messages = [];
      if (data.conversationId === this.conversation.id) {
        if (data.messageType.includes("chat.photo")) {
          this.messages = this.messages.concat(convertData(data.messages));
          this.dayList = groupByDay(this.messages);
        } else if (data.messageType.includes("share.file")) {
          this.messages = data.messages;
        } else {
          this.messages = data.messages;
        }
      }    
    },
    fetchDataInfo(conversation, pageSize = 40) {
      this.messages = [];
      switch (this.tabType) {
        case 'media':{
          this.$http.post("/api/messageV2/filter", {
            conversationId: conversation.id,
            accountId: conversation.accountId,
            timestamp: "",
            msgTypes: ["chat.photo", "chat.video.msg"],
            pageSize: pageSize,
          })         
          break;
        }
        case 'file': {
          this.$http.post("/api/messageV2/filter", {
            conversationId: conversation.id,
            accountId: conversation.accountId,
            timestamp: "",
            msgTypes: ["share.file"],
            pageSize: pageSize,
          })
          break;
        }
        case 'link': {
          this.$http.post("/api/messageV2/filter", {
            conversationId: conversation.id,
            accountId: conversation.accountId,
            timestamp: "",
            msgTypes: ["chat.link"],
            pageSize: pageSize,
          })
          break;
        }
        default:
          break;
      }
    },
    onResetSelectMulti() {
      this.selectMulti = !this.selectMulti;
      if (this.$refs.messageMedia) {
        this.$refs.messageMedia.resetSelect();
      }
      if (this.$refs.messageFile) {
        this.$refs.messageFile.resetSelect();
      }
      if (this.$refs.messageLink) {
        this.$refs.messageLink.resetSelect();
      }
    },
    loadMoreImg(round) {
      this.fetchDataInfo(this.conversation, round * 40);
    }
  },
  mounted() {
    this.tabType = this.messageType;
    // this.getMessage();

    this.$bus.$on("updateImageOrVideoTab", () => {
      if (this.tabType === "media") {
        this.fetchDataInfo(this.conversation);
      }
    });
    this.$bus.$on("updateFileTab", () => {
      if (this.tabType === "file") {
        this.fetchDataInfo(this.conversation);
      }
    });
    this.$bus.$on("updateLinkTab", () => {
      if (this.tabType === "link") {
        this.fetchDataInfo(this.conversation);
      }
    });

    window.addEventListener("click", () => {
      this.isMenuVisible = false;
    });
    this.$bus.$on("filterMessageTab", (data) => {
      this.handleFilterMessageTab(data);
    });
  },
  beforeDestroy() {
    // this.$bus.$off("updateImageOrVideoTab");
    // this.$bus.$off("updateFileTab");
    // this.$bus.$off("updateLinkTab");
  },
};
</script>

<style lang="scss" scoped>
.z2-info-storage {
  position: absolute;
  width: 300px;
  height: 100vh;
  top: 0;
  z-index: 99;
  background-color: white;
}
.btn-header {
  position: absolute;
  top: 14px;
  right: 4px;
}
</style>